module.exports = __webpack_public_path__ + "media/images/paper-c5f09805554dc3efae0aeb90ec93e78b.mp4";